import { useTranslation } from "react-i18next";
import { Badge, Grid, Text } from "@mantine/core";
import dayjs from "dayjs";
import { CampaignInquiryQueryDataType } from "src/hooks/campaignInquiries";
import { checkCountryCode } from "src/utils/helpers";

import { FormItem } from "../../../FormItem";
import { RichTextEditor } from "../../../RichTextEditor";

export interface CampaignInquiryGeneralProps {
    campaignInquiry: CampaignInquiryQueryDataType;
}

export const CampaignInquiryGeneral = ({ campaignInquiry }: CampaignInquiryGeneralProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <>
            <Grid>
                <Grid.Col xs={12} md={6}>
                    <FormItem label={t("campaign_name")}>
                        {campaignInquiry?.name || <Text color="dimmed">-</Text>}
                    </FormItem>
                </Grid.Col>
                <Grid.Col xs={12} md={6}>
                    <FormItem label={t("campaign_timeline_openat")}>
                        {campaignInquiry?.settings?.openAt ? (
                            dayjs(campaignInquiry.settings.openAt).format("DD.MM.YYYY")
                        ) : (
                            <Text color="dimmed">-</Text>
                        )}
                    </FormItem>
                </Grid.Col>
            </Grid>
            {/*
              TTV2-1720: the "Weby" list that shared this row is gone — the country beside it
              is the web, and the inquiry form has never asked the client for anything else.
            */}
            <Grid>
                <Grid.Col xs={12} md={6}>
                    <FormItem label={t("country")}>
                        {campaignInquiry?.tenant?.id && checkCountryCode(campaignInquiry?.tenant?.id) ? t(`country_${campaignInquiry.tenant.id}`) : "-"}
                    </FormItem>
                </Grid.Col>
            </Grid>
            <Grid>
                <Grid.Col xs={12} sm={6} md={6}>
                    <FormItem label={t("campaign_capacity")}>
                        {campaignInquiry?.settings?.capacity || <Text color="dimmed">-</Text>}
                    </FormItem>
                </Grid.Col>
                <Grid.Col xs={12} sm={6} md={6}>
                    <FormItem mb="xs" label={t("campaign_tags")}>
                        {!campaignInquiry?.tags?.length && <Text color="dimmed">-</Text>}
                        {(campaignInquiry?.tags || []).map((tag, index) => (
                            <Badge key={`${index}${tag?.key || tag?.text}`}>{tag?.text || tag?.key}</Badge>
                        ))}
                    </FormItem>
                </Grid.Col>
            </Grid>
            <Grid>
                <Grid.Col xs={12} sm={12} md={12}>
                    <FormItem label={t("campaign_description")}>
                        <RichTextEditor value={campaignInquiry?.description} readOnly />
                    </FormItem>
                </Grid.Col>
            </Grid>
        </>
    );
};
